import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {
    createAuthAwareQueryClient,
    SessionGuardProvider
} from '@flexinet/auth-components';
import {theme} from "./theme.ts";
import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {ModalsProvider} from "@mantine/modals";

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import '@flexinet/ui-components/style.css'


import {AuthProvider} from "./providers/AuthProvider.tsx";
import {VerifiedPermissionsProvider} from './providers/VerifiedPermissionsProvider.tsx';
import {actions} from "./config/rbac/actions.ts";
import {routesConfig} from "./config/routes.tsx";
import {UserAttributesProvider} from "./providers/UserAttributesProvider.tsx";
import {UserAccountProvider} from "./providers/UserAccountProvider.tsx";

const router = createBrowserRouter(routesConfig)
const queryClient = createAuthAwareQueryClient()


export const App = () => {
    return (
        <MantineProvider theme={theme}>
            <Notifications position={'bottom-left'}/>
            <SessionGuardProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <UserAttributesProvider>
                            <UserAccountProvider>
                                <VerifiedPermissionsProvider actions={actions}>
                                    <ModalsProvider>
                                        <RouterProvider router={router}/>
                                    </ModalsProvider>
                                </VerifiedPermissionsProvider>
                            </UserAccountProvider>
                        </UserAttributesProvider>
                    </AuthProvider>
                </QueryClientProvider>
            </SessionGuardProvider>
        </MantineProvider>
    );
}
